import React, { Component } from 'react';

export default class NotFound extends Component {
  render() {
    return (
      <div className="container">
        <h1>404!</h1>
        <p>Oops, no such page exists.</p>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/containers/misc/NotFound.js
 **/